export default "__VITE_ASSET__DZA69vMq__"